<div class="text-center">
    <div class="selectYear"><b>Select Year</b></div>
    <ng-select #yearSelect [items]="year$" bindLabel="value" [multiple]="false" [closeOnSelect]="true"
        [clearable]="true" [loading]="yearLoading" [typeahead]="yearInput$" typeToSearchText="Year Name"
        [virtualScroll]="true" [(ngModel)]="selectedYear"></ng-select>
    <i class="fa fa-search" style="right: 40px !important; top: 36px !important;"></i>
</div>